module.exports = __webpack_public_path__ + "img/step4.2f08e3bd.png";